module.exports = __webpack_public_path__ + "img/works_xikemu_dx_4.06189cb7.jpg";